import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import classes from "./CooperationCenters.module.css";
import { testUrl } from "../BaseData";

const CooperationCenters = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await axios.get(testUrl + "/api/cooperation-centers/");
        setCenters(response.data);
      } catch (error) {
        console.error("Error fetching cooperation centers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCenters();
  }, []);

  const getCenterName = (center) => {
    return center[`name_${i18n.language}`] || center.name_uz || t("no_name_available");
  };

  if (loading) return <p>Yuklanmoqda...</p>;

  return (
    <div className={classes.container}>
      <h1 className={classes.title}>{t("Xorijiy hamkorlik markazlari")}</h1>
      <div className={classes.cardsGrid}>
        {centers.map((center, index) => (
          <div
            key={center.id || index}
            className={classes.card}
            onClick={() => navigate(`/cooperation-centers/${center.short_name}`)}
          >
            <div className={classes.imageWrapper}>
              <img src={center.image} alt={getCenterName(center)} />
            </div>
            <h3 className={classes.cardTitle}>{getCenterName(center)}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CooperationCenters;
